<template>
	<div 
		class="percentage-wrapper" 
		:style='{"background-color": achtergrondKleur}'>
		<div 
			id="percent" 
			class="percentage"
			:style='{"background-color": vulKleur}'>
		</div>
	</div>
</template>

<script>

	const vueObject = {
		name: 'Percentage',
		props: ['achtergrondKleur', 'vulKleur'],
		mounted: function() {
			const percentLabel = document.querySelector("#percent");

			window.addEventListener("scroll", () => {
				let scrollTop = window.scrollY;
				let docHeight = document.body.offsetHeight;
				let winHeight = window.innerHeight;
				let scrollPercent = scrollTop / (docHeight - winHeight);
				let scrollPercentRounded = Math.round(scrollPercent * 100);

				percentLabel.style.width = scrollPercentRounded + '%';
			});			
		}
	}

	export default vueObject;
</script>

<style lang="scss">
	.percentage-wrapper {
		position: fixed;
		position: -webkit-fixed;
		top: 0px;
		// top: 71px;
		height: 10px;
		// background: $moss;
		width: 100%;
		z-index: 100;

		.percentage {
			// background: $peach;
			height: 100%;
			width: 0%;
			transition: width .1s linear;
		}
	}

	@media(max-width: 768px) {
		.percentage-wrapper {
			// top: 54px;
			top: 0px;
		}
	}
</style>